/* Theme scripts: mobile menu, product gallery, variant picker, collection sort. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Mobile menu
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-site-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Product gallery thumbnails
    // (Shopify can drop the empty data-gallery-main attribute, so fall back to the main box's image.)
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var mainBox = gallery.querySelector('.gallery__main');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      if (!mainBox || !thumbs.length) return;
      function show(thumb) {
        var main = gallery.querySelector('[data-gallery-main]') || mainBox.querySelector('img');
        if (!main) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.getAttribute('data-src');
        main.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      }
      function step(dir) {
        var i = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
        if (i < 0) i = 0;
        show(thumbs[(i + dir + thumbs.length) % thumbs.length]);
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { show(thumb); });
      });
      // Swipe left/right on the big photo (phones), tap right/left half on desktop too.
      var startX = null, startY = null;
      mainBox.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
      });
      mainBox.addEventListener('click', function (e) {
        var r = mainBox.getBoundingClientRect();
        step(e.clientX - r.left > r.width / 2 ? 1 : -1);
      });
      if (thumbs.length > 1) mainBox.classList.add('gallery__main--multi');
    });

    // Variant picker
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('input[name="id"]');
      var button = form.querySelector('[data-add-button]');
      var buttonLabel = form.querySelector('[data-add-label]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var gallery = document.querySelector('[data-gallery]');
      var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';

      function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        var noDecimals = value.replace(/\.00$/, '');
        return moneyFormat
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/, value);
      }

      function selected() {
        var values = [];
        form.querySelectorAll('[data-option-group]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          values[parseInt(group.getAttribute('data-option-group'), 10)] = checked ? checked.value : null;
        });
        return values;
      }

      function update() {
        var values = selected();
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return values[i] === undefined || values[i] === null || values[i] === opt;
          });
        });
        if (!variant) {
          button.disabled = true;
          buttonLabel.textContent = 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        button.disabled = !variant.available;
        buttonLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (variant.featured_media && gallery) {
          var thumb = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
          if (thumb) thumb.click();
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      form.querySelectorAll('[data-option-group] input').forEach(function (input) {
        input.addEventListener('change', update);
      });
    });

    // Collection sort
    var sort = document.querySelector('[data-sort-by]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  });
})();
